import { IconButton } from "@mui/material";
import { CustomTooltip, MuiBox, MuiTypography } from "components/atoms";
import React from "react";
import { useDispatch } from "react-redux";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import Close from "assets/images/svg-icons/closeIcon.svg";
import { closeSecondCenterModal } from "store/slices/SecondCenterModal.slice";

const CenterModalHeader = ({
  subTitle,
  title,
  iconSrc,
  tootipTxt = "Add",
  secondClose = false,
}) => {
  const dispatch = useDispatch();
  return (
    <MuiBox
      sx={{
        bgcolor: "background.white",
        p: "16px 20px",
        borderRadius: "12px 12px 0px 0px",
      }}
    >
      <MuiBox
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
          <MuiBox sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <MuiTypography
              variant="20"
              fontWeight={"600"}
              sx={{ color: "text.darkBlack", wordBreak: "break-word" }}
            >
              {title}
            </MuiTypography>
            {iconSrc && (
              <CustomTooltip title={tootipTxt}>
                <IconButton sx={{ height: "24px", width: "24px", p: 0 }}>
                  <img src={iconSrc} alt="help" className="img-full" />
                </IconButton>
              </CustomTooltip>
            )}
          </MuiBox>
          {subTitle && (
            <MuiTypography
              variant="14"
              fontWeight={"400"}
              sx={{ color: "text.lightgray", wordBreak: "break-word" }}
            >
              {subTitle}
            </MuiTypography>
          )}
        </MuiBox>
        <IconButton
          sx={{ p: "5px" }}
          onClick={() => {
            if (secondClose) {
              dispatch(closeSecondCenterModal());
            } else {
              dispatch(closeCenterModal());
            }
          }}
        >
          <img src={Close} alt="closeIcon" />
        </IconButton>
      </MuiBox>
    </MuiBox>
  );
};

export default CenterModalHeader;
